import React from 'react';
import { t } from '../../../../services/i18nService';
import styles from '../../testOverview.scss';

const HardwareInstructions = () => (
    <div className={styles.hardwareInstructions}>
        <p>{t('hardwareAccessCheck.instructions.paragraph_1')}</p>
        <p>{t('hardwareAccessCheck.instructions.paragraph_2')}</p>
        <p>{t('hardwareAccessCheck.instructions.paragraph_3')}</p>
    </div>
);

export default HardwareInstructions;
